var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"grey--text text-body-2 text--darken-3 secondary-font"},[_vm._v(_vm._s(_vm.$i18n.t('chat.messages.notification.' + _vm.meta.type, { user: _vm.$utils.capitalize(_vm.authorId), date: _vm.$moment(_vm.createdAt).format('HH:mm') })))])
}
var staticRenderFns = []

export { render, staticRenderFns }